import type { AnchorHTMLAttributes } from "react";

/** A real link that navigates inside the app on a plain click and keeps new-tab behavior. */
export function Link({
  go,
  href,
  onClick,
  ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  go: (path: string) => void;
}) {
  return (
    <a
      {...props}
      href={href}
      onClick={(e) => {
        onClick?.(e);
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
          return;
        e.preventDefault();
        go(href);
      }}
    />
  );
}
